module.exports = {
  api: {
    // 正式环境：部署在 pcmall.pandayoufu.com / www.pandayoufu.com 时使用。
    // 显式写 https：原来用协议相对的 '//api.pandayoufu.com'，在 http 页面（本地 dev 就是 http）
    // 上会去请求 http://，80 端口那套 vhost 只要和 443 有一点差异（CORS 头 / 重定向 / 网关），
    // 浏览器侧就是一条跨域报错；显式 https 在 http 与 https 页面下都可用，
    // 也顺带避免 https 页面请求 http 的混合内容拦截
    prod: 'https://api.pandayoufu.com',
    // 测试环境 / 本地：部署在 pcmall-test.pandayoufu.com 或 npm run serve 时使用。
    // 主接口这一档也就是「预发布」档：主接口没有独立的预发布域名
    //（2026-10 实测：apiv2-canary 只服务 apiv2；pre-api / api-canary / pre-pc / pcmall-pre 均不存在），
    // 与 h5 一致（h5 的预发布与测试在主接口上是同一个网关）。
    // 例外：电影（/v1/ju/movies/*）与景点（/v2、/v1/ctrip/* 的目录类接口）数据只配在正式环境，
    // 这两个域单独走正式网关，见 src/config/api.js 的 movie / tour 服务
    test: 'https://test-api.pandayoufu.com'
    // test: '//shop.api'
  },
  client_v: '0.0.1',
  amapWebServeKey: '335fa17e1811ae757b1cb37cc3b990e5',
  // 请求加 loading 效果的接口白名单（按地址片段匹配：命中就在请求期间显示全局 loading）。
  // 说明：注释原来写的是"正则匹配规则"，但实现是 url.includes(item)（见 createHttpService 的
  // shouldShowLoading），所以这里写地址片段就行，不用写正则。
  // 两个"下单"接口：后端处理较慢（含第三方占座/校验），都需要转圈提示；
  // 请求成功、失败、超时都会自动关掉 loading
  whiteListForLoading: ['create-movie', 'ctrip/order/create'],
  // 不做「无效值不发送」校验的接口（按地址片段匹配，命中就原样发送）。
  // 默认全局开启校验：''、纯空白、null、undefined、NaN、[]、{}、
  // 'undefined'/'null'/'NaN' 这类空值字段不发给后端（0 / false 会保留）。
  // 个别接口确实需要把空值发出去时，除了在这里配置，也可以单次请求传 { validate: false }
  //
  // create-movie（电影下单）：必须原样带上 id_no / user_name —— 未实名时它们是空串，
  // 之前被「无效值不发送」过滤掉，PC 请求体里就少了这两个字段（h5 是 id_no=&user_name= 原样发的），
  // 后端据此报参数错误，表现就是"电影购买失败"
  skipValueValidateUrls: ['create-movie'],
  // 面包屑里「当前页」那一格怎么处理：
  //   'grey' 置灰显示（留着这一格、但不做成链接，点了没反应）
  //   'hide' 不显示（整格去掉）
  // 单个页面想单独覆盖：<Bread current-mode="hide"></Bread>
  breadCurrentMode: 'grey',
  // 不加载全局面包屑的页面(部分页面需要单独添加面包屑以达到设计图需要的样式)
  hideBread: [
    '/',
    '/home',
    '/mall',
    '/movie',
    '/movie/film',
    '/movie/cinema',
    '/movie/movie_detail',
    '/login',
    '/tour',
    '/lucky_wheel',
    '/lucky/exchange',
    '/activity',
    '/mall/active_lists',
    '/festival_channel',
    '/pc_activity',
    '/pc_partition',
    '/err',
    '/business_settlement',
    '/live_service',
    '/life_privilege',
    '/birthday',
    '/private_school',
    '/partition',
    // 兑换专区：与 /partition、/pc_activity、/pc_partition 一致，面包屑由页面自己加在 banner 上
    '/exchange'
  ],
  // 不加载版心的页面--（部分页面需要width为满屏）
  hideContent: [
    '/movie/movie_detail',
    '/lucky_wheel',
    '/activity',
    '/mall/active_lists',
    '/pc_activity',
    '/pc_partition',
    '/partition',
    // 兑换专区：banner 需要铺满整屏
    '/exchange'
  ],
  // 不显示header购物车入口的页面(正则验证规则)
  hideCart: [
    '/movie',
    '/tour',
    '/userCenter',
    '/order',
    '/activity',
    '/festival_channel',
    '/pc_activity',
    '/pc_partition',
    // 兑换专区：与 /activity、/pc_activity、/pc_partition 一致
    '/exchange'
  ],
  // header显示专场切换的路由
  showSwitchPath: [
    '/',
    '/home',
    '/mall',
    '/movie',
    '/movie/film',
    '/movie/cinema',
    '/tour',
    '/lucky_wheel',
    '/activity',
    '/festival_channel',
    '/business_settlement',
    '/live_service',
    '/life_privilege',
    '/birthday',
    '/private_school',
    '/partition'
  ],
  routeMapping: [
    {
      pc: 'http://longtian.pandayoufu.com/',
      mobile: 'http://mall.pandayoufu.com/custom_home?custom_id=69'
    },
    {
      pc: 'http://shris.pandayoufu.com/',
      mobile: 'http://mall.pandayoufu.com/custom_home?custom_id=70'
    }
    // {
    //   pc: 'http://localhost:8080/mall?channel_id=10',
    //   mobile: 'http://www.baidu.com'
    // }
  ]
};
